<!--
 * @Author: yyl
 * @Date: 2025-06-26 08:55:40
 * @LastEditTime: 2025-07-02 16:05:48
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/home/CardTwoColumn.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <el-row :gutter="24">
    <el-col :xs="24" :md="12">
      <div class="card">
        <div class="card-title">
          <div class="card-title--left">
            <i class="el-icon-tickets"></i>
            {{ params.title }}
          </div>
        </div>
        <div>
          <el-image class="card-image" :src="oneData.thumb_pic" />
        </div>
        <div class="card-content" @click="handleGoDetailClick(oneData)">
          {{ oneData.title }}
        </div>
        <div class="card-subtitle">{{ oneData.created_at }}</div>
      </div>
    </el-col>

    <el-col :xs="24" :md="12">
      <!-- <CardList :sectionId="params.section_id" :list-data="listData"></CardList> -->

      <CardOneColumn
        :params="params"
        :hasTitle="false"
        :twoColumn="true"
      ></CardOneColumn>
    </el-col>
  </el-row>
</template>

<script>
// import CardList from "@/components/home/CardList.vue"
import CardOneColumn from "@/components/home/CardOneColumn.vue"

export default {
  components: { CardOneColumn },

  props: {
    params: {
      type: Object,
    },
  },

  data() {
    return {
      oneData: {},
      listData: [],
    }
  },

  watch: {
    params: {
      deep: true,
      immediate: true, // （可选）立即触发一次
      handler() {
        this.getData()
      },
    },
  },

  mounted() {},

  methods: {
    getData() {
      const articles = this.params.articles || []

      this.oneData = articles[0] || {}
      this.listData = articles.filter((item) => item.id != this.oneData.id)
    },

    handleGoListClick() {
      const item = this.params

      if (this.params.content_model_id == 2) {
        this.$router.push("/list", {
          section_id: String(item.id),
          title: item.title,
        })
      } else if (this.params.content_model_id == 3) {
        this.$router.push("/list-image", {
          section_id: String(item.id),
          title: item.title,
        })
      }

      // this.$router.push(
      //   `/list?section_id=${this.params.section_id}&title=${this.params.title}`
      // )
    },
    handleGoDetailClick(item) {
      this.$router.push(`/article?id=${item.id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  // height: 470px;
  height: auto;
  color: #565656;
  font-size: 16px;
}

.card-title {
  padding: 0 4px;
  border-bottom: 3px solid #b4d13d;
}

.card-title--left {
  color: #42679f;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  padding: 14px 4px;
}

.card-title--right {
  font-size: 14px;
  line-height: 18px;
  text-align: right;
  padding: 14px 0;
  cursor: pointer;
}

.card-image {
  display: block;
  width: 100%;
  height: auto;
  // background-color: skyblue;
}

.card-content {
  font-size: 15px;
  padding: 10px 0;
  min-height: 42px;
  cursor: pointer;
  &:hover {
    color: #15458b;
    text-decoration: underline;
  }
}

.card-subtitle {
  font-size: 13px;
}
</style>
